import { useContext, useEffect, useMemo, useRef, useState } from "react"
import { Urls } from "../../../services/Urls";
import services from "../../../services/services";
import _ from "underscore";
import { callautopopulate } from "../../../services/callautopop";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ToastContext } from "../../../context/ToastContext";

export const useExam = () => {
    const { showSuccess, showInfo} = useContext(ToastContext);
    const [newExamDialog, setNewExamDialog] = useState(false);
    const [examSelected, setExamSelected] = useState({});
    const [isNewExam, setIsNewExam] = useState(false);
    const [technologySelected, setTechnologySelected] = useState({});
    const [filterTech, setFilterTech] = useState({});
    const [name, setName] = useState("");
    const [levelOpt] = useState([{name: "Basic", value: "Basic"}, {name: "Intermediate", value: "Intermediate"}, {name: "Advance", value: "Advance"}]);
    const [level, setLevel] = useState("");
    const [dateSelected, setDateSelected] = useState({ 0: new Date() });
    const [questionsSelected, setQuestionsSelected] = useState([]);
    const [userSelected, setUserSelected] = useState({});
    const [examsList, setExamsList] = useState([]);
    const [techOptions, setTechOptions] = useState([]);
    const [quesOptions, setQuesOptions] = useState([]);
    const [userOptions, setUserOptions] = useState([]);
    const [dataFlag, setDataFlag] = useState(false);
    const [dates, setDates] = useState([0]);
    const [showExam, setShowExam] = useState(false);
    const [remarks, setRemarks] = useState("");
    const [examUser, setExamUser] = useState({});
    const [examInfo, setExamInfo] = useState([]);
    const examRef = useRef([]);
    const currParticipant = useRef([]);
    const [showUserDetails, setShowUserDetails] = useState(false);
    const tagRef = useRef(null);
    const gridRef = useRef(null);
    const [showAction, setShowAction] = useState(false);
    const [actionOf, setActionOf] = useState("");
    const [rowDatas, setRowDatas] = useState([]);
    const [rowDatas1, setRowDatas1] = useState([]);
    const [columnDefs1] = useState([
        {
            field: "exam_date",
            headerName: "Exam Date",
            width: 80,
            wrapHeaderText: true,
            autoHeaderHeight: true,
        },
        {
            field: "employee_id",
            headerName: "Employee Id",
            width: 80,
            wrapHeaderText: true,
            autoHeaderHeight: true,
        },
        {
            field: "participant_name",
            headerName: "Participants",
            width: 120,
            cellRenderer: (params) => {
                return (
                    <div className='exam-detail-participant'>{params.value}</div>
                )
            }
        },
        {
            field: "total_marks",
            headerName: "Total",
            width: 60,
            wrapHeaderText: true,
            autoHeaderHeight: true,
            cellRenderer: (params) => {
                return (
                    <div className='exam-marks-right'>{params.value}</div>
                )
            }
        },
        {
            field: "obtain_marks",
            headerName: "Obtain",
            width: 60,
            wrapHeaderText: true,
            autoHeaderHeight: true,
            cellRenderer: (params) => {
                return (
                    <div className='exam-marks-right'>{params.value}</div>
                )
            }
        },
        {
            field: "result_status",
            headerName: "Result",
            width: 50,
            wrapHeaderText: true,
            autoHeaderHeight: true,
            cellRenderer: (params) => {
                return (
                    <div style={{ color: params.value.toLowerCase() === "fail" ? "red" : (params.value.toLowerCase() === "pass" ? "green" : "") }}>{params.value}</div>
                )
            }
        },
        {
            field: "result_remark",
            headerName: "Remark",
            width: 150,
            wrapHeaderText: true,
            autoHeaderHeight: true,
            cellRenderer: (params) => {
                return (
                    <div>{params.value ? params.value : "-"}</div>
                )
            }
        },
    ]);
    const [columnDefs] = useState([
        {
            field: "question_title",
            headerName: "Questions",
            width: 200
        },
        {
            field: "total_marks",
            headerName: "Total",
            width: 60,
        },
        {
            field: "obtained_marks",
            headerName: "Obtain",
            width: 60,
            cellRenderer: (params) => {
                return (
                    <div>
                        {params.data.question_title !== "Total" ? (
                            <input type='number' defaultValue={params.data.obtain_marks} onBlur={(e) => handleUpsertMarks(e, params, null)} />
                        ) : (
                            <>{params.data.obtain_marks}</>
                        )}
                    </div>
                )
            }
        },
        {
            field: "remarks",
            headerName: "Remark",
            width: 90,
            cellRenderer: (params) => {
                return (
                    <div>
                        {params.data.question_title !== "Total" ? (
                            <input type='text' defaultValue={params.data.remark} onBlur={(e) => handleUpsertMarks(null, params, e.target.value)} />
                        ) : (
                            <></>
                        )}
                    </div>
                )
            }
        },
        {
            field: "delete",
            headerName: "Delete",
            width: 60,
            cellRenderer: (params) => {
                return (
                    <div>{params.data.result_id != null ? <FontAwesomeIcon icon="fa-solid fa-trash" onClick={() => handleDeleteExamResult(params.data.result_id)}/> : <></>}</div>
                )
            }
        },
    ])

    useEffect(() => {
        sessionStorage.removeItem("technologies");
        callautopopulate("technologies","users").then(res => {            
            setTechOptions(res?.technologies)
            setUserOptions(res?.users?.map((user) => ({ user_display_name: user.user_display_name, value: user.user_code })).sort((a, b) => a.user_display_name?.localeCompare(b.user_display_name)));
        })
    }, [])

    useEffect(() => {
        if (!_.isEmpty(technologySelected)) {
            getQuestionList();
        }
    }, [technologySelected])

    useEffect(() => {
        GetExamList();
    }, [filterTech])

    // get list of exam
    const GetExamList = async () => {        
        setDataFlag(false);
        try {
            const payload = {
                tech_id: _.isEmpty(filterTech) ? 0 : filterTech.tech_id
            }
            const res = await services.getInvokeRemote("POST", Urls("GETEXAMLIST"), payload);
            if (res) {                
                const data = res?.body?.data?.question_list;

                let exams = [];

                data?.forEach((item) => {                    
                    let obj = {
                        exam_name: item.exam_name,
                        exam_id: item.exam_id,
                        tech_id: item.tech_id,
                        tech_name: item.tech_name,
                        question_ids: [item.question_id],
                        exam_level: item.exam_level != null ? item.exam_level : "",
                        dates: {}
                    };

                    if (_.isEmpty(_.findWhere(exams, { exam_id: item.exam_id }))) {
                        exams.push(obj);
                    } else {
                        const index = _.indexOf(exams, _.findWhere(exams, { exam_id: item.exam_id }));
                        exams[index]?.question_ids?.push(item.question_id);
                    }
                })

                const examIds = _.pluck(data, "exam_id");
                examIds?.forEach((id) => {
                    const tempData = _.where(data, { exam_id: id });
                    let tempObj = {};
                    tempData?.forEach((item) => {
                        if(item.exam_date != null) {
                            if (!_.includes(Object.keys(tempObj), item.exam_date.split("T")[0])) {
                                tempObj[item.exam_date.split("T")[0]] = [item.user_code];
                            } else {
                                tempObj[item.exam_date.split("T")[0]].push(item.user_code);
                            }
                        }
                    })
                    Object.keys(tempObj)?.forEach((key) => {
                        tempObj[key] = _.uniq(tempObj[key]);
                    })

                    const indexTemp = _.indexOf(exams, _.findWhere(exams, { exam_id: id }));

                    exams[indexTemp].dates = tempObj;
                })
                
                setExamsList(exams);
                setDataFlag(true);
            }

        } catch (error) {
            console.error("Error: ", error);
        }
    }

    // create new exam popup
    const handleCreateNew = () => {
        setExamSelected({});
        setTechnologySelected(filterTech);
        setIsNewExam(true);
        setName("");
        setDates([0]);
        setUserSelected({});
        setDateSelected({ 0: new Date() });
        setQuesOptions([]);
        setQuestionsSelected([]);
        setLevel({});
        setNewExamDialog(true);
    }

    // create new exam API
    const handleUpsertNewExam = async () => {
        try {
            if (_.isEmpty(technologySelected) || _.isEmpty(questionsSelected) || name.length === 0 || _.isEmpty(userSelected)) {
                showInfo("Info", "No field should be empty");
                return;
            }
            const arr = [];
            Object.values(dateSelected)?.forEach((date) => {
                arr.push(date.toLocaleDateString("en-GB"));
            })
            const tempArr = _.uniq(arr);
            if (arr.length != tempArr.length) {
                showInfo("Info", "Same date selected more than once");
                return;
            }

            if (Object.keys(dateSelected)?.length != Object.keys(userSelected)?.length) {
                showInfo("Info", "Please fill all the data of the dates added");
                return;
            }

            let participants = [];

            Object.keys(dateSelected)?.forEach((idx) => {
                userSelected[idx]?.forEach((user) => {
                    let obj = {
                        exam_date: dateSelected[idx].toLocaleDateString("en-GB").split("/").reverse().join("-"),
                        participants_ids: user
                    }
                    participants.push(obj);
                })
            })

            const payload = {
                "exam_id": isNewExam ? 0 : examSelected.exam_id,
                "tech_id": technologySelected.tech_id,
                "exam_name": name,
                "exam_level": level,
                "question_ids": _.uniq(_.pluck(questionsSelected, "question_id")).toString(),
                "tvp_exam_participants": participants
            }

            const res = await services.getInvokeRemote("POST", Urls("UPSERTEXAMDATA"), payload);
            if (res) {
                showSuccess("success", res?.body?.message);
                setNewExamDialog(false);
                GetExamList();
            }


        } catch (error) {
            console.error("Error: ", error);
        }

    }

    // get question list for dropdown
    const getQuestionList = async () => {
        try {
            const payload = {
                tech_id: technologySelected.tech_id,
            }
            const res = await services.getInvokeRemote("POST", Urls("GETQUESTIONLIST"), payload);
            if (res) {
                const data = res?.body?.data?.question_list;
                setQuesOptions(data);

                if (!_.isEmpty(examSelected)) {

                    let questions = [];
                    examSelected.question_ids?.forEach((que) => {
                        const obj = _.findWhere(data, { question_id: que });
                        if (obj) {
                            questions.push(obj);
                        }
                    })
                    setQuestionsSelected(questions);
                } else {
                    setQuestionsSelected([]);
                }
            }

        } catch (error) {
            console.error("Error: ", error);
        }
    }

    // set all fields to edit in popup
    const handleEditExam = (exam) => {
        setIsNewExam(false);
        const levelFind = _.findWhere(levelOpt, {name: exam.exam_level});
        setLevel(levelFind?.name);
        setExamSelected(exam);
        setTechnologySelected(_.findWhere(techOptions, { tech_id: exam.tech_id }));
        setName(exam.exam_name);

        let obj = {};
        let datesTemp = [];
        let userObj = {};
        Object.keys(exam.dates)?.forEach((date, index) => {
            obj[index] = new Date(date);
            datesTemp.push(index);

            userObj[index] = exam.dates[date];
        })
        setDates(datesTemp);
        setUserSelected(userObj);
        setDateSelected(obj);
        setNewExamDialog(true);
    }    

    const handleAddDate = () => {
        if (dateSelected[dates.length - 1] === undefined) {
            showInfo("Info", "Please select dates for all the fields added!");
            return;
        } else {
            setDates([...dates, dates.length]);
        }
    }

    const handleDateChange = (index, e) => {
        setDateSelected((prev) => ({ ...prev, [index]: e.target.value }))
    }

    // get exam details individually
    const handleGetExamDetails = async (exam) => {
        setShowExam(false);
        setExamUser({});
        try {
            setExamInfo(exam);
            examRef.current = exam;
            const payload = {
                exam_id: exam.exam_id
            }
            const res = await services.getInvokeRemote("POST", Urls("GETEXAMDETAILS"), payload);
            if (res) {
                const users = res?.body?.data?.["user_list "];
                let row = [];
                users?.forEach((user) => {
                    const obj = {
                        exam_id: exam.exam_id,
                        user_code: user.user_code,
                        participant_name: user.user_display_name,
                        obtain_marks: user.obtain_marks != null ? parseFloat(user.obtain_marks) : "-",
                        total_marks: user.total_marks != null ? parseFloat(user.total_marks) : "-",
                        exam_date: user.exam_date.split("T")[0],
                        result_status: user.result_status != null ? user.result_status : "",
                        employee_id: user.employee_id,
                        result_remark: user.result_remark
                    }
                    if (_.isEmpty(_.findWhere(row, { user_code: user.user_code }))) {
                        row.push(obj);
                    }
                })
                setRowDatas1(_.sortBy(row, 'exam_date'));

                setShowExam(true);
                setShowUserDetails(false);
            }

        } catch (error) {
            console.error("Error: ", error);
        }
    }

    const handleParticipantClick = (rowdata) => {
        const user = {
            exam_id: rowdata?.data?.exam_id,
            user_code: rowdata?.data?.user_code,
            user_display_name: rowdata?.data?.participant_name,
            employee_id: rowdata?.data?.employee_id
        }
        getParticipantDetail(user);
    }

    // get partcipant details individually
    const getParticipantDetail = async (user) => {        
        setShowUserDetails(false);
        try {
            const payload = {
                "exam_id": user.exam_id,
                "participant_id": user.user_code
            }
            const res = await services.getInvokeRemote("POST", Urls("GETPARTICIPANTDETAIL"), payload)
            if (res) {
                currParticipant.current = user;
                const data = res?.body?.data?.participant_detail;

                setRemarks(data?.[0]?.result_remark);

                let row = [];
                data?.forEach((item) => {
                    if (_.isEmpty(_.findWhere(row, { question_id: item.question_id }))) {
                        row.push(item);
                    }
                    const index = _.findIndex(row, { question_id: item.question_id })
                    if (index != -1) {
                        row[index].exam_id = user.exam_id;
                        row[index].user_code = user.user_code;
                        row[index].user_display_name = user.user_display_name;
                        row[index].employee_id = user.employee_id;
                    }
                })

                const totalMarksTot = _.pluck(data, "total_marks");
                const obtainMarksTot = _.pluck(data, "obtain_marks");

                const obj = {
                    question_title: "Total",
                    total_marks: calculateTotals(totalMarksTot),
                    obtain_marks: calculateTotals(obtainMarksTot),
                }

                row.push(obj);

                setRowDatas(row);

                setExamUser(user);
                setShowUserDetails(true);
            }

        } catch (error) {
            console.error("Error: ", error);
        }
    }    

    // total marks row
    const calculateTotals = (arr) => {
        let sum = 0;
        arr?.forEach((item) => {
            sum += (item);
        })
        return parseInt(sum);
    }

    // upsert marks
    const handleUpsertMarks = async (event, rowdata, remark) => {
        if(remark == null) {
            if (event.target.value > rowdata.data.total_marks) {
                showInfo("info", "Obtained marks cannot be greater than total marks.");
                return;
            }
        }
        
        let obtain = 0;
        let remarks = "";

        if(event == null) {
            remarks = remark;
            obtain = rowdata.data.obtain_marks;
        } else if(remark == null) {
            remarks = rowdata.data.remark == null ? "" : rowdata.data.remark;
            obtain = parseInt(event.target.value);
        }

        try {
            const payload = {
                "exam_id": rowdata.data.exam_id,
                "question_id": rowdata.data.question_id,
                "obtain_marks": obtain,
                "participant_id": rowdata.data.user_code,
                "remark": remarks
            }

            const res = await services.getInvokeRemote("POST", Urls("UPSERTEXAMRESULT"), payload);
            if (res) {
                showSuccess("success", res.body?.message);
                handleGetExamDetails(examRef.current);
                getParticipantDetail(currParticipant.current);
            }

        } catch (error) {
            console.error("Error: ", error);
        }
    }

    // upsert remark of exam participant individually
    const handleSetRemark = async (val) => {
        const count = val?.split(" ")?.length;
        if (count < 10) {
            showInfo("Info", "Please enter more than 10 words");
            return;
        } else {
            try {
                const payload = {
                    "participant_id": rowDatas?.[0].participant_id,
                    "result_remark": val
                }
                const res = await services.getInvokeRemote("POST", Urls("UPSERTEXAMPARTICIPANTREMARK"), payload);
                if (res) {
                    showSuccess("success", res?.body?.message);
                }

            } catch (error) {
                console.error("Error: ", error);
            }
        }
    }      
    
    // to delete exam
    const handleDeleteExam = async (exam) => {
        try {
            const payload = {
                "exam_id": exam.exam_id
            }
            const res = await services.getInvokeRemote("POST", Urls("DELETEEXAM"), payload);
            if(res) {
                setShowExam(false);
                showSuccess("success", res?.body?.message);
                GetExamList();
            }
        } catch (error) {
            console.error("Error: ", error);
        }
    }

    // delete saved marks of each question participant wise
    const handleDeleteExamResult = async (id) => {
        try {
            const payload = {
                result_id: id,
            }
            const res = await services.getInvokeRemote("POST", Urls("DELETEEXAMRESULT"), payload)
            if(res) {
                showSuccess("success", res?.body?.message);
                handleGetExamDetails(examRef.current);
                getParticipantDetail(currParticipant.current);
            }
        } catch (error) {
            console.error("Error: ", error);
        }
    }

    return useMemo(() => ({
        tagRef, techOptions, filterTech, setFilterTech, handleCreateNew, dataFlag, examsList, handleGetExamDetails, actionOf, setActionOf, showAction, setShowAction, handleEditExam, handleDeleteExam, showExam, examInfo, showUserDetails, examUser, columnDefs1, rowDatas1, handleParticipantClick, gridRef, columnDefs, handleSetRemark, rowDatas, remarks, newExamDialog, setNewExamDialog, isNewExam, name, setName, technologySelected, setTechnologySelected, levelOpt, level, setLevel, quesOptions, questionsSelected, setQuestionsSelected, dates, dateSelected, handleDateChange, userOptions, userSelected, setUserSelected, handleAddDate, handleUpsertNewExam
    }), [tagRef, techOptions, filterTech, setFilterTech, handleCreateNew, dataFlag, examsList, handleGetExamDetails, actionOf, setActionOf, showAction, setShowAction, handleEditExam, handleDeleteExam, showExam, examInfo, showUserDetails, examUser, columnDefs1, rowDatas1, handleParticipantClick, gridRef, columnDefs, handleSetRemark, rowDatas, remarks, newExamDialog, setNewExamDialog, isNewExam, name, setName, technologySelected, setTechnologySelected, levelOpt, level, setLevel, quesOptions, questionsSelected, setQuestionsSelected, dates, dateSelected, handleDateChange, userOptions, userSelected, setUserSelected, handleAddDate, handleUpsertNewExam])
}